/* 出典つきの図に「著作権申立」のリンクを自動で足す（作成側が書かなくてよい）。
   リンク先は、記事のハンドルと画像のURLを持つ申し立てのページ。 */
(function () {
  'use strict';
  try {
    var figs = document.querySelectorAll('figure.fp-cite');
    if (!figs.length) return;
    var m = location.pathname.match(/\/blogs\/[^/]+\/([^/?#]+)/);
    var handle = m ? decodeURIComponent(m[1]) : '';
    if (!handle) return;
    Array.prototype.forEach.call(figs, function (fig) {
      if (fig.querySelector('.fp-cite__claim')) return;
      var img = fig.querySelector('img');
      var cap = fig.querySelector('figcaption');
      if (!img || !cap || !img.getAttribute('src')) return;
      var a = document.createElement('a');
      a.className = 'fp-cite__claim';
      a.rel = 'nofollow';
      a.textContent = '著作権申立';
      a.href = '/pages/copyright-claim?article=' + encodeURIComponent(handle) + '&img=' + encodeURIComponent(img.getAttribute('src'));
      cap.appendChild(a);
    });
  } catch (e) { /* 表示を止めない */ }
})();
